<template>
  <v-form novalidate :disabled="disabled" @submit.prevent="submit">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        <v-container>
          <InputTitleSlug
            :is-loading="loading"
            :title="fields.name"
            :title-error="validationErrors.name"
            :slug="fields.slug"
            :slug-error="validationErrors.slug"
            :isSlugEnabled="isNew"
            @change:title="fields.name = $event"
            @change:slug="fields.slug = $event"
            @input:slug="$v.fields.slug.$touch"
          />
          <v-row>
            <v-col cols="12">
              <SeoSettings
                :loading="disabled || loading"
                :data="data"
                @on-input-seo="fields = Object.assign({}, fields, $event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="!isShowCheckboxForKiosk" cols="12">
              <span>Для киосков</span>
              <v-checkbox
                hide-details
                dense
                :loading="loading"
                v-model="fields.forKiosks"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" v-if="!!infoCategories && data">
              <span>Родительская категория</span>
              <v-select
                v-model="fields.parentCategoryId"
                ref="selectParentCategory"
                outlined
                item-value="id"
                item-text="name"
                clearable
                :items="
                  infoCategories.filter(
                    category => category.id !== data.id && category.parentId === null
                  )
                "
                :disabled="disabled"
                :loading="loading"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="grey--text"> Локализация </span>
              <v-select
                outlined
                item-value="value"
                item-text="title"
                hide-details
                dense
                :items="$options.contentLocales"
                :disabled="disabled"
                :loading="loading"
                :value="language"
                @change="updateLocaleHandler"
              />
            </v-col>
          </v-row>
                    <v-row>
            <v-col cols="12">
              <span class="grey--text"> Сортировка </span>
              <v-text-field
                outlined
                dense
                :loading="loading"
                :disabled="disabled"
                :value="fields.sortOrder"
                @change="fields.sortOrder = Number($event)"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="mt-auto">
        <v-spacer />
        <v-btn
          block
          color="success darken-2"
          type="submit"
          :disabled="disabled"
          :loading="loading"
        >
          {{ !!id ? 'Создать' : 'Сохранить' }}
        </v-btn>
      </v-card-actions>
      <v-card-actions class="mt-auto">
        <v-btn
          width="100%"
          type="button"
          text
          color="grey darken-1"
          :disabled="disabled"
          @click="$emit('cancel')"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mixForm } from '@/utils/form.mix.js'
import validationTranslations from '@/mixins/translations/validationTranslations.mix.js'
import prepareTranslations from '@/mixins/translations/prepareTranslations.mix'

import { contentLocales } from '@/configs/locales.js'

import validationRules from './validation-rules'

import SeoSettings from '@/components/seo-settings'
import FormAbstract from '@/components/abstract/form'
import InputTitleSlug from '@/components/inputs/InputTitleSlug'

export default {
  name: 'FormInfoCategory',
  contentLocales,
  components: {
    InputTitleSlug,
    SeoSettings
  },
  extends: FormAbstract,
  mixins: [validationTranslations, prepareTranslations, mixForm],
  validationRules,
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: null
    },
    language: {
      type: String,
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    infoCategories: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      fields: {
        name: null,
        slug: undefined,
        forKiosks: false,
        seoMetaTitle: null,
        seoMetaDescription: null,
        seoDisallowIndex: false,
        seoMetaKeywords: null,
        seoRelCanonical: null,
        seoOgImageId: null,
        parentCategoryId: null,
        translations: { ru: { isEnabled: true } },
        sortOrder: null
      }
    }
  },
  computed: {
    isShowCheckboxForKiosk () {
      return !!this.data?.parentCategory || null || this.id
    },
    validationRulesVars () {
      return { infoCategoryId: this.data?.id, ctx: this, isNew: !this.isNew }
    },
    isNew () {
      return !!this.data?.id || false
    }
  },
  watch: {
    fields: {
      deep: true,
      handler (newVal) {
        if (newVal.forKiosks && newVal.parentCategoryId) {
          this.fields.parentCategoryId = null
        }
      }
    },
    data: {
      deep: true,
      handler (newVal) {
        this.populateInfoCategoryForm(newVal)
      }
    }
  },
  methods: {
    updateLocaleHandler (value) {
      this.$emit('language-update', value)
    },
    async submit () {
      const isValid = await this.validate()
      if (!isValid) {
        this.mixScrollToError(this.$v)
        return
      }
      const payload = {
        ...this.composeFormData(this.fields)
      }

      this.$emit('submit', payload)
    },
    populateInfoCategoryForm (data) {
      if (Object.keys(data)?.length > 0) {
        this.populate(data)
        this.fields.parentCategoryId = data?.parentCategory?.id || null
      } else {
        this.fields.parentCategoryId = this.id
      }
    }
  },
  mounted () {
    this.populateInfoCategoryForm(this.data)
  }
}
</script>
